module.exports = __webpack_public_path__ + "img/wx_offical_account.c9945f49.jpg";